<!-- 公共组件--查看短信内容 -->
<template>

  <div>
    <div class="mobile-box" :style="{ background: 'url(' + mobileScreen + ') no-repeat' }">
      <div class="sms-center">
        <div class="message-content" v-if="title || text">
          <!-- 标题 -->
          <div v-if="title">
            <p style="font-weight: bold;">{{ title }}</p>
          </div>
          <!-- 文本内容 -->
          <div v-if="text">
            <p>{{ text }}</p>
          </div>
        </div>
        <div v-if="mediaList.length">
          <!-- 多媒体内容 -->
          <div v-for="item, index in mediaList" :key="index">
            <!-- 图片 -->
            <div class="message-content2" v-if="item.busiType == 20">
              <el-image style="max-width: 190px;border-radius: 6px;" :src="item.fileUrl" :preview-src-list="imgList"
                :z-index="99999">
              </el-image>
            </div>
            <!-- 音频 -->
            <div class="message-content3" v-if="item.busiType == 21">
              <div v-if="!item.isPlays"><img src="@/assets/images/音频播放键.png" @click="playAudio(item, true, index)">
              </div>
              <div v-else><img src="@/assets/images/音频暂停键.png" @click="playAudio(item, false, index)"></div>
              <div><img src="@/assets/images/音频播放条.png"></div>
              <div> {{ formatTime(item.totalTimes) }} </div>
            </div>
            <!-- 视频 -->
            <div class="message-content2" v-if="item.busiType == 22">
              <video style="max-width: 190px;border-radius: 6px;" id="myvideo" controlslist="nodownload" ref="curVideo"
                preload="auto" controls="controls">
                <source :src="item.fileUrl" type="video/mp4">
              </video>
            </div>
          </div>
        </div>
        <div>
          <div class="message-content" v-if="title || text || mediaList.length != 0">
            拒收请回复R
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import { mediaDetail } from "@/api/smsSend";

export default {
  props: {
    // 富信模板id
    id: {
      default: ''
    },
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 内容
    text: {
      type: String,
      default: ''
    },
    mediaListJsonArray:{
      type:Array,
    }
  },
  data() {
    return {
      mobileScreen: require("@/assets/images/mobileScreen.png"), // 预览图地址
      imgList: [], // 预览图列表
      audioTimer: null, // 音频计数器
      mediaList: [], // 模板内容
    }
  },
  created() {
  },
  mounted() {
    // 获取富媒体列表
    if(this.id){
      mediaDetail(this.id).then(res => {
      // console.log(res);
      if (res.code == 1) {
        this.mediaList = res.data.map(item => item)
        console.log(this.mediaList);
        this.mediaList.forEach(async (item, index) => {
          // 音频处理
          if (item.busiType == 21) {
            item.isPlays = false
            this['player' + index] = new Audio(item.fileUrl)
            item.totalTimes = await this.countAudioTime(this['player' + index])
            this.$forceUpdate()
          }
          // 图片预览图处理
          if (item.busiType == 20) {
            this.imgList.push(item.fileUrl)
          }
        })
      }
      })
    }else{
      this.mediaList =this.mediaListJsonArray
      this.mediaList.forEach(async (item, index) => {
        // 音频处理
        if (item.busiType == 21) {
          item.isPlays = false
          this['player' + index] = new Audio(item.fileUrl)
          item.totalTimes = await this.countAudioTime(this['player' + index])
          this.$forceUpdate()
        }
        // 图片预览图处理
        if (item.busiType == 20) {
          this.imgList.push(item.fileUrl)
        }
      })
    }

    
 
  },
  methods: {
    close() {
      this.mediaList.forEach((item, index) => {
        if (item.busiType == 21) {
          this['player' + index].pause();
        }
      })
      this.$emit('close', false);
    },
    // 计算音频的时长
    async countAudioTime(player) {
      while (isNaN(player.duration) || player.duration === Infinity) {
        // 延迟一会 不然网页都卡死
        await new Promise(resolve => setTimeout(resolve, 200));
        // 设置随机播放时间，模拟调进度条
        player.currentTime = 10000000 * Math.random();
      }
      return parseInt(player.duration)
    },
    // 播放音频
    async playAudio(item, flag, index) {
      let _this = this
      this.mediaList.forEach(lab => {
        lab.isPlays = false
      })
      item.isPlays = flag
      this.$forceUpdate()
      clearInterval(this.audioTimer)
      if (flag) {
        this.mediaList.forEach((item, index) => {
          if (item.busiType == 21) {
            this['player' + index].pause();
          }
        })
        // 开始播放
        this['player' + index].play()
        // 音频倒计时
        this.audioTimer = setInterval(async () => {
          item.totalTimes--
          this.$forceUpdate()
          // 倒计时结束
          if (item.totalTimes <= 0) {
            clearInterval(this.audioTimer)
            item.totalTimes = await this.countAudioTime(this['player' + index])
            item.isPlays = false
            this.$forceUpdate()
          }
        }, 1000)
      } else {
        clearInterval(this.audioTimer)
        // 暂停播放
        this['player' + index].pause();
      }
    },
    formatTime(secs) {
      let minutes = Math.floor(secs / 60) || 0;
      let seconds = (secs - minutes * 60) || 0;
      return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
    },
  }
}
</script>

<style lang="scss" scoped>
.mobile-box {
  position: relative;
  width: 256px;
  height: 504px;

  .sms-center {
    overflow: auto;
    width: 244px;
    height: 335px;
    position: relative;
    top: 93px;
    left: 0;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .message-content {
    word-wrap: break-word;
    padding: 6px 10px;
    border-radius: 10px;
    display: inline-block;
    max-width: 190px;
    min-width: 97px;
    font-size: 12px;
    background-color: #E5E6EA;
    line-height: 18px;
    margin-left: 15px;
    text-align: left;
    margin-top: 2px;
  }

  .message-content2 {
    max-width: 190px;
    margin-left: 15px;
    margin-top: 2px;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    img {
      max-width: 190px;
      border-radius: 6px;
    }
  }

  .message-content3 {
    background-color: #E5E6EA;
    border-radius: 15px;
    max-width: 136px;
    height: 31px;
    margin-left: 15px;
    margin-top: 2px;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    >div {
      &:nth-child(1) {
        width: 34px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 25px;
          height: 25px;
          cursor: pointer;
        }
      }

      &:nth-child(2) {
        width: 72px;
        display: flex;
        align-items: center;
        padding-left: 4px;

        img {
          width: 28px;
          height: 18px;
        }
      }

      &:nth-child(3) {
        flex: 1;
        color: #ADADAD;
        font-size: 12px;
      }
    }
  }
}
</style>